export default {
  API_URI: process.env.VUE_APP_API_URI || "http://localhost:3000",
  SOCKET_IO_ROOT: process.env.VUE_APP_SOCKET_IO_ROOT || "http://localhost:3000",
  SOCKET_IO_PATH: process.env.VUE_APP_SOCKET_IO_PATH || "/socket.io/",
};
